export default __webpack_public_path__ + "static/media/sleep-apnea.c353aebf.svg";